import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getWishlist, addWishlist, removeWishlist } from "@common/utils/cart"

// Initial state
const initialState = {
  wishlistItems: [],
  loading: false,
  error: null,
}

// Async thunks
export const fetchWishlist = createAsyncThunk("wishlist/fetchWishlist", async (_, { rejectWithValue }) => {
  try {
    const response = await getWishlist()
    return response?.data
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export const addToWishlist = createAsyncThunk("wishlist/addToWishlist", async (productId, { rejectWithValue }) => {
  try {
    const response = await addWishlist(productId)
    return response?.data
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export const removeFromWishlist = createAsyncThunk(
  "wishlist/removeFromWishlist",
  async (productId, { rejectWithValue }) => {
    try {
      const response = await removeWishlist(productId)
      return response?.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

// Wishlist slice
const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    clearWishlist: (state) => {
      state.wishlistItems = []
      localStorage.removeItem("wishlistData")
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch wishlist
      .addCase(fetchWishlist.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchWishlist.fulfilled, (state, action) => {
        state.loading = false
        state.wishlistItems = action.payload?.product || []
      })
      .addCase(fetchWishlist.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Add to wishlist
      .addCase(addToWishlist.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addToWishlist.fulfilled, (state, action) => {
        state.loading = false
        state.wishlistItems = action.payload?.product || []
      })
      .addCase(addToWishlist.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Remove from wishlist
      .addCase(removeFromWishlist.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(removeFromWishlist.fulfilled, (state, action) => {
        state.loading = false
        state.wishlistItems = action.payload?.product || []
      })
      .addCase(removeFromWishlist.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

// Export actions and reducer
export const { clearWishlist } = wishlistSlice.actions
export default wishlistSlice.reducer

// Selectors
export const selectWishlistItems = (state) => state.wishlist.wishlistItems
export const selectWishlistLoading = (state) => state.wishlist.loading
export const selectWishlistItemCount = (state) => state.wishlist.wishlistItems.length
